export default {
    purchase: 'Kauf',
    coupon: 'Coupon',
    login_capital_letters: 'Anmelden',
    login_capital_letters1: 'Anmelden',
    received: 'Erhalten',
    subscribe_capital_letters: 'Abonnieren',
    birthday_placeholder: 'MM/TT/JJ',
    shop_capital_letters: 'Einkaufen',
    shop: 'Einkaufen',
    ecoflow_benefits: 'EcoCredits-Vorteile',
    complete_profile: 'Profil vervollständigen',
    referral: 'Freundschaftswerbung',
    referral_desc: 'Sammeln Sie EcoCredits für jede erfolgreiche Freundschaftswerbung.',
    referral_btn: 'Jetzt teilnehmen',
    warranty: 'Garantie',
    points_activity_a: 'Meine Aktivität',
    points_tab_name: 'EcoCreditsaktivität',
    rewards_tab_name: 'Belohnungsaktivität',
    coupon_used_desc: 'Benutzen Sie diesen Code beim Auschecken, um Ihren {amont}-Gutschein einzulösen.',
    email_address: 'Mailadresse',
    give_away: 'Verschenken',
    add_my_birthday: 'Meinen Geburtstag hinzufügen',
    ins_title: 'Folgen Sie uns auf Instagram',
    ins_desc1: 'Sie erhalten {points} EcoCredits, wenn Sie uns zum ersten Mal folgen.',
    ins_desc2: 'Sie erhalten {points} EcoCredits, wenn Sie uns zum ersten Mal folgen.',
    follow_button: 'Jetzt folgen',
    subscribe: 'Abonnieren',
    welcome_top_bar: 'EcoCredits Aktionswoche x Xmax.\n Jetzt bestellen >>',
    welcome_title: 'Hallo {username}',
    welcome_sub_title: 'Willkommen beim EcoCredits Prämienprogramm.',
    profile: 'Profil',
    status: 'Status',
    refund: 'Rückerstattung',
    points_balance: 'EcoCredits-Guthaben',
    points_progress_tips: 'Benötigte EcoCredits zum Erreichen der {plus}: {points} EcoCredits',
    available: 'Verfügbar',
    sign_up_text: '500 EcoCredits für die Registrierung als neues Mitglied',
    redeemed_succ: 'Das Einlösen war erfolgreich!',
    current_tier: 'Aktuelle Tier',
    subscribe_now: 'Jetzt abonnieren',
    date: 'Datum',
    used: 'Verwendet',
    edeemed_rewards_note: 'Hier werden Ihre eingelösten Prämien angezeigt.',
    warranty_capital_letters: 'Garantie',
    days_rules2: 'Gültig ab {data}.',
    redeem_now: 'JETZT EINLÖSEN',
    product_rules: 'Nur für {product}',
    membership_includes: 'IN DER MITGLIEDSCHAFT IST ENTHALTEN',
    browse_ecocredits_rewards: 'EcoCredits-Prämien durchsuchen',
    discount: 'Rabatt',
    view_more: 'Mehr anzeigen',
    profile_desc1: 'Für die Vervollständigung Ihres Profils erhalten Sie bis zu 1 000 EcoCredits.',
    profile_desc2: 'Erhalten Sie 1 000 EcoCredits, indem Sie Ihre Daten hinzufügen.',
    points_capital_letters: 'EcoCredits',
    history_note:
        'Ihre EcoCreditsaktivität wird hier angezeigt. Ihre EcoCredits werden noch nicht angezeigt? Ihre EcoCreditsaktivität wird innerhalb von 24 Stunden aktualisiert.',
    lucky_flop_start: 'Jetzt teilnehmen',
    lucky_flop_congrat: 'Herzlichen Glückwunsch',
    lucky_flop_get: 'Preis beanspruchen',
    lucky_flop_open: 'umdrehen',
    rules: 'Regeln',
    completed_text: 'Diese EcoCredits haben Sie bereits erhalten.',
    completed_text2: 'Sie haben bereits so viele EcoCredits gesammelt.',
    redeemed: 'Eingelöst',
    birthday: 'GEBURTSTAG',
    summary_text: 'Ihre EcoCredits-Übersicht',
    deducted: 'Abgezogen',
    site_rules: 'Nur für DE-Shop.',
    subscribe_hover: 'Sie erhalten 500 EcoCredits, wenn Sie ihn abonnieren.',
    subscribe_text: 'Abonnieren Sie den EcoFlow-Newsletter.',
    store: 'Jetzt kaufen',
    membership: 'MITGLIED',
    join_now: 'MITGLIED WERDEN',
    gift_card: 'Geschenkkarte',
    rewards_redeemed: 'Meine Belohnungen',
    redeedmed_tab_name: 'Eingelöst',
    issued_tab_name: 'Ausgegeben',
    expired: 'Abgelaufen',
    login: 'ANMELDEN',
    earn_points_title: 'So sammeln Sie EcoCredits',
    have_points: 'Sie haben <code>{points} EcoCredits</code>',
    view_all: 'Alle sehen',
    add_your_birthday: 'Geburtstag hinzufügen',
    earn_point_rule_shop: 'Für jeden Euro Ihres Bestellwerts erhalten Sie 1 EcoCredit.',
    off: 'Rabatt',
    earn_point_by_order: 'Sie erhalten für jede Bestellung EcoCredits.',
    registered: 'Registriert',
    birthday_desc2: 'Sie erhalten {points} EcoCredits, wenn Sie Ihr Geburtsdatum hinzufügen.',
    sign_up_desc_h: 'Erstellen Sie ein Konto und erhalten Sie 500 EcoCredits.',
    birthday_desc1: 'Fügen Sie Ihren Geburtstag hinzu und erhalten Sie EcoCredits.',
    or_text: 'ODER',
    profile_a: 'Profil',
    days_rules: 'Gültig für {days} Tage ab Einlösung',
    join_title: 'Machen Sie mit beim EcoCredits Prämienprogramm',
    pending: 'In Bearbeitung',
    coming_soon: 'Bald verfügbar',
    shop_to_earn_points: 'Kaufen Sie ein und erhalten Sie EcoCredits',
    action: 'Aktion',
    rewards_title: 'Belohnungen',
    question_title: 'Quiz spielen',
    type_title: 'Art',
    discount_type: 'Rabatt',
    already_member: 'Sind Sie bereits Mitglied?',
    already_member1: 'Sind Sie bereits Mitglied?',
    points_activity: 'ECOCREDITSAKTIVITÄT',
    use_this_code_note: 'Benutzen Sie diesen Code beim Auschecken, um Ihren <PI1/>-Gutschein einzulösen.',
    warranty_desc2: 'Für die Registrierung Ihres Produkts erhalten Sie 1 000 EcoCredits.',
    warranty_desc1: '1 000 EcoCredits für die Registrierung Ihres Produkts',
    redeem_ecocredits_title: 'Prämien erhalten',
    redeem_ecocredits_title_next: 'Neue Produktprämien und Rabatte stehen zum Einlösen bereit. Nicht verpassen!',
    member_exclusive: '',
    redeem_ecocredits_subtitle_next: 'Registrieren Sie sich jetzt und sichern Sie sich Zubehör für Ihr Balkonkraftwerk mit 50% Prämienvorteil!',
    redeem_ecocredits_rules_title1: 'Einführung zum Event:',
    redeem_ecocredits_rules_title2: 'Event Modus:',
    redeem_ecocredits_rules_desc1:
        'Nehmen Sie zwischen dem 20. und 23. Oktober 2023 an unseren Pop-up-Events teil, um EcoCredits mit Rabatten einzulösen. Während dieser Termine erscheinen Pop-Ups nach dem Zufallsprinzip!',
    redeem_ecocredits_rules_desc2:
        '1. Überraschungen frühzeitig freischalten: Melden Sie sich an und seien Sie unter den Ersten, die über die überraschenden Startzeiten für die EcoCredits Rewards-Veranstaltungen informiert werden.',
    redeem_ecocredits_rules_desc3:
        '2. Machen Sie das Beste aus Ihren EcoCredits: Bei jedem Pop-Up Event können Sie von einem Rabatt von bis zu 50 % auf den Punktetausch profitieren. Aber handeln Sie schnell! Die Anzahl der beteiligten Produkte ist begrenzt. Jeden Tag stehen vier einzigartige Produkte im Mittelpunkt der Aktion, von denen jeweils maximal 100 Stück verfügbar sind.',
    points: 'EcoCredits',
    benefits_link_btn: 'Jetzt weiterempfehlen',
    network_error: 'Netzwerkfehler',
    manually_added: 'Manuell hinzugefügt',
    confirm_text: 'Möchten Sie wirklich einlösen? Dieser Vorgang kann nicht rückgängig gemacht werden.',
    manually_deducted: 'Manuell abgezogen',
    redeeming_points: 'ECOCREDITS EINLÖSEN',
    earning_points: 'ECOCREDITS SAMMELN',
    confirm_btn: 'Bestätigen',
    faq_title: 'Häufig gestellte Fragen',
    no_enough_points: 'Aufgrund unzureichender EcoCredits ist das Einlösen fehlgeschlagen.',
    no_history_note: 'Ihre EcoCredits werden noch nicht angezeigt? Es kann bis zu 24 Stunden dauern, bis Ihre Aktivität angezeigt wird.',
    no_coupon_note: 'Noch keine Gutscheine eingelöst.',
    minimum_price: 'Mindestausgaben ({price}).',
    minimum_num: 'Mindestmenge an Artikeln ({num} Stück).',
    stay_too_long: 'Ihre Session ist abgelaufen. Bitte aktualisieren Sie die Seite und versuchen Sie es erneut.',
    order_rule: 'Für jede Bestellung kann nur ein Gutscheincode verwendet werden.',
    purchas_rule: 'Wenn Sie einen Artikel für weniger als den/die Gutschein(e) kaufen, verfällt der Differenzbetrag.',
    profile_birthday: 'Profil - Geburtstag',
    profile_address: 'Profil - Adresse',
    profile_username: 'Profil- Benutzername',
    profile_picture: 'Profil - Bild',
    profile_contact: 'Profil - Kontaktinformationen',
    membership_faq_title: 'BELOHNUNGSPROGRAMM',
    learn_more: 'Mehr Erfahren',
    profile_detail:
        'Vervollständige Ihr Profil für bis zu 1000 EcoCredits, einschließlich Profilbild (200), Benutzername (100), Kontaktinformationen (300), Adresse (200) und Geburtstag (200).',
    exceeded_counts: 'Die Einlösung ist gescheitert. Sie haben das Einlöselimit überschritten.',
    grab_title: 'Holen Sie sich EcoCredits-Belohnungen',
    grab_sub_title: 'Exklusive, zeitlich begrenzte Angebote für EcoCredit-Mitglieder. Klicken Sie jetzt, um davon zu profitieren!',
    grab_btn_text: 'Meinen Belohnungen holen',
    grab_success_title: 'Herzlichen Glückwunsch',
    grab_success_text1: 'Belohnungen erfolgreich eingelöst!\n Geben Sie den Code an der Kasse ein, um Ihren Rabatt zu erhalten.',
    grab_success_text2: 'Prüfen Sie Ihre Belohnungen unter <code>"Meine Belohnungen"</code>.',
    'no-grab-content-note': 'Weitere Angebote folgen in Kürze!',
    copy_desc_2: 'Sie haben den Code kopiert.',
    city_validatino_error: 'Ungültige Ort',
    product_text: 'Produkt',
    shipping_address_text: 'Lieferadresse',
    saved_address_text: 'Gespeicherte Adressen',
    use_new_address: 'Eine neue Adresse verwenden',
    spend_now: 'Jetzt ausgeben',
    stock_left: '{stock} übrig',
    no_stock_tip: 'Bald verfügbar... Bleiben Sie dran!',
    order_text: 'Bestellung',
    campaign_time_limit_text: 'Gültiger Einlösungszeitraum:  {startTime} - {endTime}.',
    event_action_text: 'Event',
    warranty_minus_action_text: 'Garantie gelöscht',
    question_correctly: 'Beantworte die Frage korrekt',
    follow_instagram_text: 'Auf Instagram folgen',
    follow_youtube_text: 'Auf YouTube folgen',
    follow_facebook_text: 'Auf Facebook folgen',
    join_facebook_text: 'Facebook Gruppe beitreten',
    referral_correctly: 'Empfehlungsprogramms',
    confirm_btn_text: 'Schließen',
    lucky_turntable_title: 'Gewinnspiel',
    lucky_turntable_title2: 'Glücksziehung ',
    join_lucky_with_points: 'Für eine Runde Lucky Spin brauchen Sie {points} EcoCredits.',
    join_lucky_with_points2: 'Eine Spielrunde kostet {points} EcoCredits.',
    join_lucky_desc: 'Drehen Sie das Rad und holen Sie sich einen tollen Preis!',
    remaining_number: 'Noch <code></code> Drehungen übrig',
    remaining_number2: '<code></code> dreht links um',
    learn_lucky_rule: 'Mehr zu den Regeln',
    prize_coupon_title: 'Herzlichen Glückwunsch',
    prize_coupon_sub_title: 'Der Preis wurde erfolgreich beansprucht! Für Rabatte den Code an der Kasse verwenden.',
    prize_coupon_action: 'Überprüfen Sie Ihre Gewinne unter <code>Meine Belohnungen</code>.',
    prize_coupon_button: 'Jetzt einkaufen',
    prize_points_title: 'Herzlichen Glückwunsch',
    prize_points_desc: 'Überprüfen Sie die hinzugefügten EcoCredits in <code>Meine Aktivitäten</code>.',
    limit_times_in_day: 'Sie können das Rad <count></count> Mal in <day></day> Tagen drehen',
    limit_times_in_day2: 'Sie können die Karten <count></count> mal in <day></day> Tagen umdrehen',
    limit_times_in_active: 'Während der Veranstaltung können Sie das Rad bis zu <count></count> Mal drehen.',
    limit_times_in_active2: 'Während des Events können die Karten bis zu <count></count>mal umgedreht werden.',
    without_limit_times: 'Sie können das Rad jederzeit <count></count> mal drehen.',
    without_limit_times2: 'Sie können die Karten jederzeit <count></count> Mal umdrehen.',
    active_is_unstart: 'Dieses Event beginnt in Kürze.',
    active_is_ended: 'Dieses Event ist beendet.',
    over_max_count: 'Sie haben die Anzahl der verfügbaren Drehungen überschritten.',
    notice_title: 'Hinweis',
    appreciationday: 'EcoCredits Aktionswoche',
    members_nav: 'Mitgliederpreise',
    referral_nav: 'Einen Freund werben',
    points_cash: 'Punkteeinlösung',
    Pending1: 'In Bearbeitung',
    rollback: 'Zurückgegeben',
    level_change_log: 'Aktivitätsstufe',
    deadline: 'Gültig bis',
    history_refresh_member: 'Mitglied',
    history_refresh_plus_member: 'PLUS Mitglied',
    register: 'Als Mitglied registrieren',
    upgrade: 'Upgrade zum PLUS Mitglied',
    demotion: 'Mitgliedsstatus zurückstufen',
    relegation: 'PLUS Mitglied bleiben',
    product_hot_title: 'Top Angebote',
    product_hot_desc: 'Beim Kauf von EcoFlow DELTA Pro 3 und erhalten Sie eine Transportkarre GRATIS!',
    product_refurbished_title: 'Generalüberholte Produkte – Bessere Deals für kurze Zeit!',
    product_refurbished_desc: '17. Okt., 9:00 Uhr (MEZ) - 28. Okt., 8:59 Uhr (MEZ) ',
    wattayear_2024: '#WattAYearTeilen',
    clock_in: '',
    copy_success1: 'Sie haben den Code kopiert. Bitte gehen Sie zum Shop, um ihn einzulösen.',
};
